import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants/app-routes.const';
import { TipoResultado } from '@shared/models/busqueda-global.model';

/**
 * Traduce un resultado del buscador a la ruta que le corresponde.
 *
 * Existe para no duplicar el `switch` por tipo en el componente: si mañana
 * cambia la ruta de una familia, cambia en un sitio. Registrar el resultado en
 * RECIENTES es responsabilidad del llamador (`BusquedaRecientesService`).
 */
@Injectable({ providedIn: 'root' })
export class BusquedaNavegacionService {
  private readonly router = inject(Router);

  /** Abre el detalle en la misma pestaña, o en una nueva con `nuevaPestana`. */
  abrir(r: { tipo: TipoResultado; id: number }, nuevaPestana = false): void {
    const commands = this.comandos(r);

    if (nuevaPestana) {
      const url = this.router.serializeUrl(this.router.createUrlTree(commands));
      window.open(url, '_blank', 'noopener');
      return;
    }

    void this.router.navigate(commands);
  }

  private comandos(r: {
    tipo: TipoResultado;
    id: number;
  }): (string | number)[] {
    switch (r.tipo) {
      // Misma ruta que abre el listado de despachos de PROVEEDOR_PRODUCTO.
      case 'despacho':
        return [APP_ROUTES.DESPACHO.DETALLE, r.id];
      case 'importacion':
        return [APP_ROUTES.PROVEEDORES.DESPACHOS, r.id];
      case 'orden_compra':
        return [APP_ROUTES.ORDEN_COMPRA.DETALLE, r.id];
      case 'tarifa':
        return [APP_ROUTES.TARIFAS.SOLICITUD, r.id];
    }
  }
}
